<template>
  <div>
    <el-button style="margin-top:2.5px;" size="mini" :disabled="troubleShootingBtnFlag" type="primary" @click="clickEventTicketButton">
      장애티켓 등록
    </el-button>
    <w-event-ticket-add-popup ref="ticketAddPop" :active-tab="activeTab" :target-row-array="targetRowArray" @load-data="loadData" @close-add-popup="reset"></w-event-ticket-add-popup>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import WEventTicketAddPopup from '@/views/event/components/popup/EventTicketAddPopup';
import { mapGetters } from 'vuex';

export default {
  name: 'WEventTicketAddButton',
  components: { WEventTicketAddPopup },
  props: {
    activeTab: {
      type: String,
    },
  },
  computed: mapGetters(['selectedEvents']),
  data() {
    return {
      targetRowArray: [], // 사용자가 선택한 대상들 중 중복 대상이 걸러진 인스턴스 배열 변수
      troubleShootingBtnFlag: true,
    };
  },
  watch: {
    // 체크된 대상들이 있는 array에 watch를 사용하여 해당 이벤트들 중 어느하나라도 이미 발행된 장애티켓이 포함된다면 버튼을 비활성
    selectedEvents(targetList) {
      if (targetList.length === 0) {
        this.troubleShootingBtnFlag = true;
      } else {
        for (let i = 0; i < targetList.length; i += 1) {
          if (!isNil(targetList[i].troubleTicketGroupId)) {
            this.troubleShootingBtnFlag = true;
            break;
          } else {
            this.troubleShootingBtnFlag = false;
          }
        }
      }
    },
  },
  methods: {
    reset() {
      this.targetRowArray = [];
    },
    /*
     * 장애티켓 등록 이벤트 버튼
     * 이벤트 이력(hist)는 중복된 해시키들이 있기에 추가적인 분기 처리가 필요하다.
     * 중복된 해시키들은 현재시간 기준 가장 최근 값만을 필터링하여 넘겨주도록한다.
     */
    clickEventTicketButton() {
      this.targetRowArray = []; // 초기화
      const targetList = [];
      let flag = false;
      let temp = null;
      if (this.activeTab === 'event-hist') {
        forEach(this.selectedEvents, (item) => {
          // 첫번 째 루프 - 대상 값으로 이중 루프를 돌려 해시키가 같다면 날짜도 비교하여 저장한다. (최근 값)
          forEach(this.selectedEvents, (target) => {
            if (target.hashkeyIdString === item.hashkeyIdString) {
              if (target.checkDatetime >= item.checkDatetime) {
                temp = target;
              }
            }
          });
          flag = false; // 플래그 초기화
          // 현재 저장해놓은 배열에 같은 해시키를 가진 대상이 이미 있다면 플래그 값 변경
          forEach(targetList, (itemEx) => {
            if (itemEx.hashkeyIdString === temp.hashkeyIdString) {
              flag = true;
            }
          });
          // 플래그의 변화가 없다면 중복된 해시키가 없다는 것으로 간주, 추가한다.
          if (!flag) {
            targetList.push(temp);
          }
        });
        this.targetRowArray = targetList;
      } else {
        this.targetRowArray = this.selectedEvents;
      }
      this.$refs.ticketAddPop.open();
    },
    // EventTicketAddPop에서 전파한 이벤트이다. 장애티켓을 발행했다면 해당 이벤트 현황 혹은 이력현황을 reload해야한다.
    loadData() {
      this.$emit('load-data');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/components/EventTicketAddButton.vue